import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, InputLabel, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => {
  return {
    main: {
      ".MuiInputBase-input": {
        height: "24px",
      },
      ".MuiInputBase-root:hover fieldset": {
        borderColor: `#c4c4c4 !important`
      },
      ".MuiInputBase-root.Mui-disabled:hover fieldset": {
        borderColor: `rgba(0, 0, 0, 0.26) !important`
      },
      ".Mui-disabled": {
        backgroundColor: "#efefef",
        borderRadius: '10px',
      },
      "input": {
        padding: "6px 12px 6px 12px",
        // color: "black",
      },
      "input::placeholder": {
        color: "#7d7d7d",
        opacity: 1,
        fontSize: '14px'
      },
      ".Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: `#c4c4c4 !important`,
        borderWidth: "1px !important",
      },
      ".MuiInputBase-formControl:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: `#c4c4c4 !important`,
      },
      ".MuiInputBase-formControl.Mui-disabled:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: `#c4c4c4 !important`,
      },

    }
  };
});

const CommonTextField = ({
  text,
  type,
  placeholder,
  height,
  width,
  valid,
  multiline,
  rows,
  name,
  value,
  onChange,
  onInput,
  inputProps,
  defaultValue,
  fontWeight,
  labelSize,
  labelColor,
  showPasswordToggle,
  className,
  marginBottom,
  bgcolor,
  onKeyDown,
  onPaste,
  onBlur,
  disabled,
  whiteSpace,
  onDrag,
  size,
  borderRadius,
  backgroundColor,
  maxLength,
  subText
}) => {
  const { classes } = useStyles();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Box width={width || "auto"}>
      {text && (
        <Box mb={0.5} display="flex" fontSize="12px" flexDirection={"row"}>
          <Box display="flex" fontSize="12px" flexDirection={"column"} flexWrap={"wrap"} >
            <InputLabel
              sx={{
                letterSpacing: "0.03em",
                marginRight: "2px",
                fontWeight: fontWeight,
                fontSize: labelSize || "14px",
                color: labelColor || "#222222",
                whiteSpace: "wrap",
                marginBottom: "0px"
              }}
            >
              {text}
            </InputLabel>
            {subText && <InputLabel
              sx={{
                letterSpacing: "0.03em",
                marginRight: "2px",
                fontWeight: fontWeight,
                fontSize: "11px",
                color: labelColor || "#222222",
                whiteSpace: "wrap",
              }}
            >
              {subText}
            </InputLabel>}
          </Box>
          {valid && (
            <Typography color="#EF627A" component={"span"} variant={"body2"}>
              *
            </Typography>
          )}
        </Box>
      )}
      <TextField
        variant="outlined"
        type={type === "password" ? showPassword && showPasswordToggle ? "text" : type : type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        sx={{
          // height: height || "28px",
          width: width,
          marginBottom: marginBottom,
          backgroundColor: backgroundColor || "transparent",
          borderRadius: borderRadius || "10px",
          "& .MuiOutlinedInput-root": {
            borderRadius: borderRadius || "10px",
          },
          ".MuiInputBase-input": {
            height: height || "24px",
          },
        }}
        multiline={multiline}
        maxLength={maxLength}
        rows={rows}
        className={`${classes?.main} ${className}`}
        onInput={onInput}
        onPaste={onPaste}
        inputProps={inputProps}
        onKeyDown={onKeyDown}
        defaultValue={defaultValue}
        onDrag={onDrag}
        fullWidth
        size={size}
        InputProps={{
          ...(showPasswordToggle && {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          })
        }}
        onBlur={onBlur}
        disabled={disabled ? disabled : false}
      />
    </Box>
  );
};

export default CommonTextField;
